import axios from 'axios'

// 必有得api服务
export const APP = axios.create({
  baseURL: process.env.VUE_APP_API
})

// 参数配置
APP.extra = {
  // 接口错误信息展示
  showErrorMessage: true,
  // 取消重复请求
  cancelRepeatRequest: true
}

// 教学api服务
export const TRAIN = axios.create({
  baseURL: process.env.VUE_APP_TRAIN_API
})

// 参数配置
TRAIN.extra = {
  // 接口错误信息展示
  showErrorMessage: true,
  // 取消重复请求
  cancelRepeatRequest: true
}

// passport api服务
export const PASSPORT = axios.create({
  baseURL: process.env.VUE_APP_PASSPORT_API
})

// 参数配置
PASSPORT.extra = {
  // 接口错误信息展示
  showErrorMessage: false,
  // 取消重复请求
  cancelRepeatRequest: true
}

// passport api服务
export const PAY = axios.create({
  baseURL: '/pay-api'
})

// 参数配置
PAY.extra = {
  // 接口错误信息展示
  showErrorMessage: true,
  // 取消重复请求
  cancelRepeatRequest: true
}

export default axios
